<template>
  <div>
    <HistoryInfoBoxes :detail="info">
      <template #box0>
        <div class="pb-1 d-flex">
          <div style="width: 100px">
            {{ $t('refund.refund_target-order-number') + ':' }}
          </div>
          <div>{{ nullEmptyFormat(items.sale.transaction.controlNumber) }}</div>
        </div>
        <div class="pb-1 d-flex">
          <div style="width: 100px">
            {{ $t('refund.refund_refund-management-number') + ':' }}
          </div>
          <div>{{ nullEmptyFormat(items.transaction.controlNumber) }}</div>
        </div>
        <div class="pb-1 d-flex">
          <div style="width: 100px">{{ $t('common.input_remarks') + ':' }}</div>
          <div>{{ items.refundNote ? items.refundNote.body : '' }}</div>
        </div>
      </template>
    </HistoryInfoBoxes>
  </div>
</template>
<script>
import HistoryInfoBoxes from '@/components/items/Designs/HistoryInfoBoxes'
import {
  commonUtil,
  countryUtil,
  countryCallingCodeUtil,
  stockAdjustUtil
} from '@/util'

export default {
  components: { HistoryInfoBoxes },
  props: {
    items: { default: {} }
  },
  data: () => ({
    info: []
  }),
  created() {
    this.info = this.createList()
  },
  methods: {
    createList() {
      const info = {
        ...this.interfaceObj,
        title: 'refund.refund_refund-info'
      }

      return [info]
    },
    nullEmptyFormat(str) {
      return commonUtil.nullEmptyFormat(str, '')
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
.nameText {
  font-size: 14px;
}
</style>
